import getSearchParams from 'src/js/utils/get-search-params';

const getPartnerIdFromUrl = () => {
  const searchParams = getSearchParams();

  return searchParams.has('pid') ? searchParams.get('pid') : null;
};

export default getPartnerIdFromUrl;
